/* Copyright Verge Technologies 2018
 * @file favourites.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component responsible for housing favourites
 */

// Modules
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { ApolloConsumer } from 'react-apollo';
import _ from 'lodash';
import PubSub from 'pubsub-js';

// GraphQL
import { FAVOURITES_QUERY } from '../../graphql';

// Components
import FavouriteItem from '../FavouriteItem/favouriteItem';
import { PulseLoader } from 'react-spinners';

class Favourites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: 0,
      units: 0,
      favourites: [],
      initialLoad: true,
    };
  }

  getProducts = () => {
    // Retrieve favourites from localstorage and sanitize them
    const favourites = JSON.parse(localStorage.getItem('SEPARATIONS_FAVOURITES'));
    const returnFavourites = [];
    favourites.map((favourite) => {
      const temp = _.pick(favourite, ['id', 'quantity']);
      if (!_.isEmpty(temp)) {
        returnFavourites.push(temp);
      }
      return null
    });
    return returnFavourites;
  };

  favouritesFetched = (favourites) => {
    const newFavourites = [];
    const oldFavourites = JSON.parse(localStorage.getItem('SEPARATIONS_FAVOURITES'));
    // Need to make a clone to enable object extension
    const stateFavourite = _.cloneDeep(favourites);
    // Map through the received favourites
    stateFavourite.forEach((favourite) => {
      favourite.quantity =
        oldFavourites[oldFavourites.findIndex(fav => fav.id === favourite.hash_id)].quantity;
      newFavourites.push({
        id: favourite.hash_id,
        quantity:
          oldFavourites[oldFavourites.findIndex(fav => fav.id === favourite.hash_id)].quantity,
      });
    });
    // Write new audited favourites to storage
    localStorage.setItem('SEPARATIONS_FAVOURITES', JSON.stringify(newFavourites));

    // Update the header component
    PubSub.publish('LOCAL_UPDATE');
    this.setState({
      ...this.state,
      products: newFavourites.length,
      units: newFavourites.reduce((sum, item) => sum + item.quantity, 0),
      favourites: stateFavourite,
      initialLoad: false,
    });
  };

  fetchFavourites = async () => {
    const { data } = await this.props.client.query({
      query: FAVOURITES_QUERY,
      variables: { params: this.getProducts() },
      fetchPolicy: 'network-only',
    });
    this.favouritesFetched(data.getFavourites);
    return '';
  };

  updateQuantity = (id, event) => {
    // Get current favourites stored in state
    const stateFavourites = this.state.favourites;
    const localFavourites = JSON.parse(localStorage.getItem('SEPARATIONS_FAVOURITES'));
    // Update the quanityt
    stateFavourites[stateFavourites.findIndex(fav => fav.hash_id === id)].quantity = parseInt(
      event.target.value,
      10,
    );
    localFavourites[localFavourites.findIndex(fav => fav.id === id)].quantity = parseInt(
      event.target.value,
      10,
    );
    // Update the local storage
    localStorage.setItem('SEPARATIONS_FAVOURITES', JSON.stringify(localFavourites));
    // Update state
    this.setState({
      ...this.state,
      favourites: stateFavourites,
      units: stateFavourites.reduce((sum, item) => sum + item.quantity, 0),
    });
  };

  removeFavourite = (id) => {
    const localFavourites = JSON.parse(localStorage.getItem('SEPARATIONS_FAVOURITES'));
    _.remove(localFavourites, (item) => {
      return item.id === id;
    });
    localStorage.setItem('SEPARATIONS_FAVOURITES', JSON.stringify(localFavourites));
    const stateFavourites = this.state.favourites;
    _.remove(stateFavourites, (item) => {
      return item.hash_id === id;
    });
    // Update the header component
    PubSub.publish('LOCAL_UPDATE');
    this.setState({
      ...this.state,
      favourites: stateFavourites,
      products: stateFavourites.length,
      units: stateFavourites.reduce((sum, item) => sum + item.quantity, 0),
    });
  };

  render() {
    return (
      <ApolloConsumer>
        {() => {
          // Check if it's the initial page load
          if (this.state.initialLoad) {
            this.fetchFavourites();
          }
          // Check if the favourites array is empty and if page has loaded before
          if (_.isEmpty(this.state.favourites) && this.state.initialLoad) {
            return (<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
              <PulseLoader loading color="#004DA9" sizeUnit="px" size={15} />
            </div>);
          }
          return (
            <div className="favourites-container">
              <div className="summary">
                <h4>List Summary</h4>
                <div className="details">
                  Products:{' '}
                  <b>
                    <span>{this.state.products}</span>
                  </b>
                  <br />
                  Units:{' '}
                  <b>
                    <span>{this.state.units}</span>
                  </b>
                </div>
                <div className="control">
                  <Link
                    to={{
                      pathname: '/favourites/request-quote',
                      state: {
                        favourites: this.state.favourites,
                      },
                    }}
                    className="button button-green"
                  >
                    Request Quote
                  </Link>
                </div>
              </div>
              {
                Boolean(this.state.favourites.length) && (
                  <div className="favourites-list">
                    <div className="heading">
                      <div className="cols cols-img" />
                      <div className="cols cols-desc">Item Description</div>
                      <div className="cols cols-qty">Quantity</div>
                      <div className="cols cols-action" />
                    </div>
                    <ul className="list">
                      {this.state.favourites.map((favourite) => {
                        return (
                          <FavouriteItem
                            item={favourite}
                            key={favourite.hash_id}
                            quantityUpdate={this.updateQuantity}
                            removeItem={this.removeFavourite}
                          />
                        );
                      })}
                    </ul>
                  </div>
                )
              }
              {!this.state.favourites.length && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ padding: '10px', borderRadius: '5px', backgroundColor: 'white' }}>
                    You currently don't have any items, navigate to the products page to add some
                  </span>
                </div>
              )}
            </div>
          );
        }}
      </ApolloConsumer>
    );
  }
}

export default withRouter(Favourites);



// WEBPACK FOOTER //
// ./src/components/Favourites/favourites.js